import React from 'react';
import { NavLink } from 'react-router-dom';

import homeIcon from 'assets/icons/home.svg';

function HomeButton({ className }: IHomeButton) {
  return (
    <NavLink to="/">
      <img
        src={homeIcon}
        alt="home-icon"
        className={className}
      />
    </NavLink>
  );
}

export default HomeButton;
